import Vue from 'vue'

export default ({ $axios, store, app }, inject) => {
  const catalogEventBus = new Vue()

  // Inject currency format to context
  inject('catalogEventBus', catalogEventBus)
}
